import { Step } from "react-joyride";

export const tourStepsAbout = (): Step[] => {
  const steps: Step[] = [
    {
      target: ".hero-section",
      content:
        "This About page explains who Race The Clock is for and how it started as a fluency practice tool.",
      disableBeacon: true,
    },
    {
      target: ".audience-list",
      content:
        "It is meant for teachers and learners of many ages, from early reading to specialized adult practice.",
    },
    {
      target: ".features-section",
      content:
        "The main idea is simple: show items one at a time, control the pace, and review how a session went.",
    },
    {
      target: ".features-grid",
      content:
        "Collections, speed controls, and reports are the core. Games and the name spinner are extra practice tools.",
    },
    {
      target: ".top-navbar-height",
      content:
        "Use the menu to open Collections, Games, Reports, Settings, and more. You can start this tour again from Start Tour when tours are enabled.",
    },
  ];

  return steps;
};
